import dayjs from 'dayjs';

export default function dateFormat(value, format) {
  return dayjs(value).format(format);
}
